export default "__VITE_ASSET__e0878857__"